<template>
    <div class="counter">
        <div class="controls">
            <span>ANTAL: </span>
            <div class="filter-box">
                <span class="amount">{{bans}}</span>
                <span class="type">BANS</span>
            </div>
            <div class="filter-box">
                <span class="amount">{{mutes}}</span>
                <span class="type">MUTES</span>
            </div>
            <div class="filter-box">
                <span class="amount">{{kicks}}</span>
                <span class="type">KICKS</span>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        props: ['bans', 'mutes', 'kicks']
    }
</script>

<style lang="scss" scoped>
    .counter {
        display: flex;
        justify-content: flex-end;
        padding-bottom: 20px;
        font-size: 80%;
        color: #7c8084;

        .controls {
            display: flex;
            align-items: center;
            background: #262a2d;
            padding: 3px 3px 3px 10px;
            border-radius: 3px;
            line-height: 24px;

            > span {
                letter-spacing: .5px;
                font-weight: bold;
                padding-right: .5rem;
            }

            .filter-box {
                display: inline-block;
                margin: .25rem 0.6rem;
                min-height: 1.5rem;

                .type {
                    margin-left: 6px;
                }

                .amount {
                    color: #fff;
                }
            }
        }
    }

    @media screen and (max-width: 990px) {
        .counter{
            display: block;
            .controls{
                justify-content: space-around;
            }
        }
    }
</style>